import { apiClient } from "../config";

async function getAllConditions(queryParams: any) {
  const res = await apiClient.get(`/admin/conditions`, {
    params: queryParams,
  })
  return res.data;
}

export default getAllConditions;
